import { cn } from '@/lib/utils'
import WelcomBG from '../../../assets/welcomebg.svg'
import WomanMan from '../../../assets/womanman.svg'

export interface WelcomeHeroProps {
  userName?: string
  subtitle?: string
  heroImage?: string
  className?: string
}

export function WelcomeHero({
  userName = 'Jane',
  subtitle = 'Every step you take here helps build a stronger, healthier marriage.',
  className,
}: WelcomeHeroProps) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-[20px] bg-[#F3F4F6] w-full min-h-[329px]',
        className
      )}
    >
      <div className='relative z-10 pt-8 pb-4 px-6 md:pt-10 md:px-8'>
        <div>
          <h1 className='text-[28px] sm:text-[36px] md:text-[48px] font-medium leading-[1.17] tracking-[-1px] text-[#151515] text-start mb-4' style={{ fontFamily: 'Poppins, sans-serif' }}>
            Welcome, {userName}!
          </h1>
          <p className='text-[16px] text-[#4e4d4d] text-start font-normal leading-[32px] max-w-[400px]'>
            {subtitle}
          </p>
        </div>
      </div>

      <img src={WelcomBG} alt='Background' className='absolute bottom-0 left-0 w-full h-auto opacity-70' />

      <img
        src={WomanMan}
        alt='Happy couple'
        className='absolute right-0 bottom-0 h-[85%] w-auto hidden md:block'
      />
    </div>
  )
}
